import { create } from 'zustand';
import { Settings } from '../types';
import { api } from '../services/api';

// В дефолте НЕТ курсов валют: раньше стоял фиктивный TR:1, и пока /api/settings
// не долетел (медленный SSL-хендшейк до бэка), каталог пересчитывал цены «в лирах» —
// клиенты видели ценники в 2–3 раза ниже реальных. Теперь до прихода настроек
// карточки используют v.price из БД (посчитан парсером по реальному курсу),
// а последние успешные настройки кешируются в localStorage и подхватываются сразу.
const CACHE_KEY = 'xplay_settings_v1';

const defaultSettings: Settings = {
  availableRegions: { TR: true, IN: true, UA: true },
  exchangeRates: {} as Settings['exchangeRates'],
  rangePricing: {},
  codesRates: {},
  cardDenominations: { TR: [], IN: [], UA: [] },
  supportUrl: '',
  privacyUrl: '',
  termsUrl: '',
};

function readCachedSettings(): Settings | null {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || !parsed.exchangeRates) return null;
    return { ...defaultSettings, ...parsed };
  } catch {
    return null;
  }
}

interface SettingsStore {
  settings: Settings;
  isLoading: boolean;
  error: string | null;
  loadSettings: () => Promise<void>;
}

export const useSettingsStore = create<SettingsStore>((set) => ({
  settings: readCachedSettings() || defaultSettings,
  isLoading: false,
  error: null,

  loadSettings: async () => {
    set({ isLoading: true, error: null });
    // До 3 попыток: первый запрос падает при медленном SSL-хендшейке до бэка
    for (let attempt = 0; attempt < 3; attempt++) {
      try {
        const settings = await api.getSettings();
        set({ settings, isLoading: false });
        try {
          localStorage.setItem(CACHE_KEY, JSON.stringify(settings));
        } catch { /* приватный режим и т.п. — не критично */ }
        return;
      } catch {
        await new Promise((r) => setTimeout(r, 800 * (attempt + 1)));
      }
    }
    set({ error: 'Failed to load settings', isLoading: false });
  },
}));
